export default "__VITE_ASSET__BMbBEtXt__"